require("../css/ui.css")

document.addEventListener("DOMContentLoaded", () => {
  console.log("DOMContentLoaded", "Rush2")
})
